module.exports = __webpack_public_path__ + "static/img/zgp.2d76bf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zgp.png
// module id = Jnzi
// module chunks = 0